/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface DeliveryPayingOutputDto { 
    cdDriverPaying?: number;
    dtFecha?: Date;
    qtTotal?: number;
    qtNeto?: number;
    qtComission?: number;
    qtPaying?: number;
}